import { PlaceholderPage } from "@/components/placeholder-page";
import { getFeatureFlags } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCanAccessWorkerDocuments } from "@/features/auth/use-platform-features";

export function SettingsPage() {
  const flags = getFeatureFlags();
  const canAccessWorkerDocuments = useCanAccessWorkerDocuments();

  return (
    <div className="space-y-6">
      <PlaceholderPage
        title="Settings"
        description="Organization settings, auth, and feature flags."
      />
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Feature Flags</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>Onchain proofs</span>
            <Badge variant={flags.onchainProofs ? "default" : "outline"}>
              {flags.onchainProofs ? "Enabled (OWNER only)" : "Disabled"}
            </Badge>
          </div>
          {!flags.onchainProofs ? (
            <p className="text-xs text-muted-foreground">
              Wallet features are hidden in the MVP. Email-only login — no crypto setup required.
            </p>
          ) : null}
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>Default timezone</span>
            <span>{import.meta.env.VITE_DEFAULT_TIMEZONE ?? "America/Los_Angeles"}</span>
          </div>
        </CardContent>
      </Card>
      {canAccessWorkerDocuments ? (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Document security</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-3 text-sm text-muted-foreground">
              Review worker-document access, retention, download reasons, and recent security
              events.
            </p>
            <Link to="/settings/security/documents">
              <Button variant="outline">Open document security settings</Button>
            </Link>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
}
